import { css } from 'styled-components';

export const baseTagStyles = css`
  height: 2rem;
  min-height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  padding: 0.25rem 0.75rem;
  font-size: 14px;
  font-weight: 400;
`;
